module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.11eabca2.ttf";